import { DASHBOARD, DASHBOARD_LOW_STOCK_PRODUCTS, DASHBOARD_MONTHLY_SALES, DASHBOARD_OUTOFSTOCK_PRODUCTS } from "./types";


export const dashboardAction = (data, onSuccess, onError) => {
    return {
        type: DASHBOARD,
        data,
        onSuccess,
        onError,
    };
};

export const dashboardMontlySalesAction = (data, onSuccess, onError) => {
    return {
        type: DASHBOARD_MONTHLY_SALES,
        data,
        onSuccess,
        onError,
    };
};

export const dashboardOutOfStockProductsAction = (data, onSuccess, onError) => {
    return {
        type: DASHBOARD_OUTOFSTOCK_PRODUCTS,
        data,
        onSuccess,
        onError,
    };
};

export const dashboardLowStockProductsAction = (data, onSuccess, onError) => {
    return {
        type: DASHBOARD_LOW_STOCK_PRODUCTS,
        data,
        onSuccess,
        onError,
    };
};